enum LineHeights {
	Lg = '1.5',
	Md = '1.25',
	Sm = '1',
}

export default LineHeights;
